module.exports = __webpack_public_path__ + "static/thumb_burden-a3e2cf6c20e1c8f9fa21019ce3a48d0f.jpg";